module.exports = __webpack_public_path__ + "img/logo.ea92c55b.png";